export default class SubtitleMenuItem {
  constructor({ player } = {}) {
    this._player = player;
    this._el = undefined;
    this._kinds = (["subtitles", "captions"]).filter(Boolean);
  }

  player() { return this._player }

  label() { return "" }

  shouldBeActive() { return false }

  el() {
    if (this._el == undefined) {
        this.createEl();
    }
    return this._el;
  }

  createEl() {
    this._el = document.createElement("li");
    this._el.setAttribute('role', 'menuitem');
    this._el.setAttribute('tabindex', '0');
    const className = `vjs-subtitle-switcher__list-item ${this.label().replace(" ","-").toLowerCase()}`;
    this._el.textContent = this.label();
    this._el.className = className;

    this._player.textTracks().addEventListener('change', this.updateActiveStatus.bind(this));
    this._player.on(['loadstart', 'texttrackchange'], this.updateActiveStatus.bind(this));

    this._el.onclick = () => {
        this.handleClick();
    }
    this._el.ontouchend = () => {
      this.handleClick();
    }
    return this._el
  }

  handleClick() { }

  updateActiveStatus() {
    if (this.shouldBeActive()) {
        this.el().classList.add('is-active');
    } else {
        this.el().classList.remove('is-active');
    }
  }
}